import {
  GETTING_FREE_TRIAL_REPORT,
  UPDATE_FREE_TRIAL_REPORT_INFO,
  DOWNLOADING_FREE_TRIAL_REPORT,
  DOWNLOAD_PDF_SUCCESSFUL,
  CLOSE_DOWNLOAD_SUCCESS_TOASTER,
} from '../actions/actionTypes';

const DEFAULT_STATE = {
  freeTrialReport: null,
  loading: false,
  hasDownloadedPdf: false,
};

export const partnerReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case GETTING_FREE_TRIAL_REPORT:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_FREE_TRIAL_REPORT_INFO:
      return {
        ...state,
        freeTrialReport: action.payload,
      };

    case DOWNLOADING_FREE_TRIAL_REPORT:
      return {
        ...state,
        loading: true,
      };

    case DOWNLOAD_PDF_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        hasDownloadedPdf: true,
      };

    case CLOSE_DOWNLOAD_SUCCESS_TOASTER:
      return {
        ...state,
        hasDownloadedPdf: false,
      };

    default:
      return {
        ...state,
        loading: false,
      };
  }
};
